import React from 'react';
import { Input as ShadcnInput } from '../ui/input';
import { Label } from '../ui/label';
import { cn } from '../../lib/utils';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  className = '',
  ...props
}) => {
  return (
    <div className="w-full">
      {label && (
        <Label className="mb-2">
          {label}
        </Label>
      )}
      <ShadcnInput
        className={cn(
          error && 'border-destructive',
          className
        )}
        {...props}
      />
      {error && <p className="mt-1 text-sm text-destructive">{error}</p>}
    </div>
  );
};

